module.exports = __webpack_public_path__ + "img/optik.62d8a08c.svg";